<div class="cr-export-overlay" (click)="closeDialog.emit()">
  <section class="cr-export-dialog" role="dialog" aria-modal="true" aria-labelledby="crExportTitle" (click)="$event.stopPropagation()">
    <button type="button" class="cr-export-close" (click)="closeDialog.emit()" aria-label="Close export dialog">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M5 5l14 14"></path>
        <path d="M19 5 5 19"></path>
      </svg>
    </button>

    <div class="cr-export-body">
      <div class="cr-export-heading">
        <div class="cr-export-kicker">EXPORT CONTENT</div>
        <h2 id="crExportTitle">Export template text</h2>
        <p>Export a copy of the campaign content for reuse or sharing.</p>
      </div>

      <div class="cr-export-summary">
        <div>
          <span>Template</span>
          <strong [title]="templateName || ''">{{ templateName }}</strong>
        </div>
        <div>
          <span>Language</span>
          <strong>{{ language }}</strong>
        </div>
        <div>
          <span>Fields</span>
          <strong>{{ fieldCount }}</strong>
        </div>
      </div>

      <div class="cr-export-option-grid">
        <button type="button" class="cr-export-option-card" (click)="downloadFile()">
          <span class="cr-export-option-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12 4.5v9"></path>
              <path d="m8.5 10.5 3.5 3.5 3.5-3.5"></path>
              <path d="M5 17.5h14"></path>
            </svg>
          </span>
          <strong>Download file</strong>
          <span>Creates a Word .docx file with red input names, maximum lengths and formatted campaign content.</span>
        </button>
        <button type="button" class="cr-export-option-card selected" (click)="copyToClipboard()">
          <span class="cr-export-option-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <rect x="9" y="7" width="10" height="12" rx="2"></rect>
              <rect x="5" y="5" width="10" height="12" rx="2"></rect>
            </svg>
          </span>
          <strong>Copy to clipboard</strong>
          <span>Copies the same structure as rich text for pasting directly into Word or another editor.</span>
        </button>
      </div>
    </div>

    <div class="cr-export-footer">
      <button type="button" class="cr-export-cancel-btn" (click)="closeDialog.emit()">Cancel</button>
    </div>
  </section>
</div>
